module.exports = __webpack_public_path__ + "img/Correlatiom dash grey.37c97d85.png";